module.exports = __webpack_public_path__ + "static/media/no-applicants.bbc86843.svg";